export default __webpack_public_path__ + "static/media/menTrousers.3be7f98b.svg";